// Modül 5 - Gerçek Mülakat Soruları - İnteraktif İçerikler

const cabinCrewContentsM5Interactive = {
  // ==================== ÜNİTE 1: ZOR YOLCU SENARYOSU ====================
  'CM-M5-U1-L1': {
    lesson_id: 'CM-M5-U1-L1',
    title: 'Empati Kurma',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '💗 Empati: Zor Yolcunun Anahtarı',
      intro: 'Zor yolcu = Mutsuz yolcu. Önce ANLA!',
      facts: [
        { icon: '👂', title: 'Dinle', text: 'Önce şikayeti TAM dinle, kesme' },
        { icon: '💗', title: 'Anladığını Göster', text: '"Sizi anlıyorum, bu zor bir durum"' },
        { icon: '🙏', title: 'Özür Dile', text: 'Suçlu olmasan bile "Rahatsızlık için özür dilerim"' },
        { icon: '💡', title: 'Çözüm Sun', text: 'Alternatif veya çözüm öner' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Kızgın yolcuya ilk tepki?',
        options: [
          { text: 'Kuralları açıkla', isCorrect: false, feedback: '❌ Önce dinle ve empati kur!' },
          { text: 'Dinle, anladığını söyle', isCorrect: true, feedback: '✅ Empati = Sakinleşme!' },
          { text: 'Purser\'a yönlendir', isCorrect: false, feedback: '❌ İlk müdahale senin!' }
        ]
      }
    }
  },

  'CM-M5-U1-L2': {
    lesson_id: 'CM-M5-U1-L2',
    title: 'Prosedür Takibi',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '📋 Prosedür: Empati + Kurallar',
      intro: 'Zor yolcu yönetiminde 4 adım:',
      steps: [
        { level: 1, title: '👂 DİNLE', desc: 'Söz kesme, tam dinle' },
        { level: 2, title: '💗 EMPATIK YANIT', desc: '"Anlıyorum, zor bir durum"' },
        { level: 3, title: '💡 ÇÖZÜM SUN', desc: 'Alternatif veya açıklama' },
        { level: 4, title: '🙏 TAKİP', desc: 'Memnuniyeti kontrol et' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Yolcu sakinleşmiyorsa?',
        options: [
          { text: 'Tartış', isCorrect: false, feedback: '❌ ASLA tartışma!' },
          { text: 'Görmezden gel', isCorrect: false, feedback: '❌ Durum kötüleşir!' },
          { text: 'Purser/üstü çağır', isCorrect: true, feedback: '✅ Eskale etmeyi bil!' }
        ]
      }
    }
  },

  'CM-M5-U1-L3': {
    lesson_id: 'CM-M5-U1-L3',
    title: 'Senaryo: Zor Yolcu',
    type: 'scenario',
    duration: 5,
    xp: 55,
    scenario: {
      question: '😤 MÜLAKAT SORUSU: Zor Yolcu',
      context: '"Bir yolcu koltuk değişimi istiyor ama uçak dolu. Çok kızgın ve bağırıyor. Ne yaparsınız?"',
      options: [
        { id: 'A', text: 'Kuralları söyle, kabul etmek zorunda', isCorrect: false },
        { id: 'B', text: 'Dinle, empati kur, alternatif sun', isCorrect: true },
        { id: 'C', text: 'Hemen Purser\'a devret', isCorrect: false },
        { id: 'D', text: 'Görmezden gel, geçer', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 MÜKEMMEL! "Anlıyorum zor bir durum. Uçak şu an dolu ama inişte başka seçenek var mı bakayım"',
        wrong: '❌ Empati önce, kural sonra! Dinlemeden kural söylemek kızdırır.'
      },
      explanation: 'STAR formatında cevapla: Durum (zor yolcu) + Görev (memnun etmek) + Eylem (empati+alternatif) + Sonuç (sakinleşme)'
    }
  },

  // ==================== ÜNİTE 2: ACİL DURUM SORULARI ====================
  'CM-M5-U2-L1': {
    lesson_id: 'CM-M5-U2-L1',
    title: 'Öncelik Belirleme',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🚨 Acil Durumda Öncelik Sırası',
      intro: 'Acil durumda HER ZAMAN bu sırayı takip et:',
      steps: [
        { level: 1, title: '🚨 HAYAT', desc: 'Yolcu ve ekip güvenliği' },
        { level: 2, title: '✈️ UÇAK', desc: 'Uçak güvenliği' },
        { level: 3, title: '📦 EŞYA', desc: 'Mülk ve kargo' },
        { level: 4, title: '⏰ ZAMAN', desc: 'Program ve verimlilik' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Yangında ilk öncelik?',
        options: [
          { text: 'Yolcuları sakinleştir', isCorrect: false, feedback: '❌ Önce söndür!' },
          { text: 'Yangını söndür', isCorrect: true, feedback: '✅ Hayat önce!' },
          { text: 'Kaptana haber ver', isCorrect: false, feedback: '❌ İlk sen müdahale et!' }
        ]
      }
    }
  },

  'CM-M5-U2-L2': {
    lesson_id: 'CM-M5-U2-L2',
    title: 'Ekip Koordinasyonu',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '👥 Ekip Koordinasyonu',
      intro: 'Acil durumda ekip çalışması HAYATI!',
      facts: [
        { icon: '📢', title: 'İletişim', text: 'Net, kısa, yüksek sesli komutlar' },
        { icon: '🤝', title: 'Görev Dağılımı', text: 'Herkes görevini bilmeli' },
        { icon: '📞', title: 'Raporlama', text: 'Purser ve Kaptan\'a bilgi akışı' },
        { icon: '✅', title: 'Onay', text: 'Komutları tekrarla ve onayla' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Komut aldığında ne yapmalı?',
        options: [
          { text: 'Hemen uygula', isCorrect: false, feedback: '❌ Önce tekrarla!' },
          { text: 'Tekrarla ve uygula', isCorrect: true, feedback: '✅ "Anlaşıldı, tahliye başlatıyorum!"' },
          { text: 'Soru sor', isCorrect: false, feedback: '❌ Acilde zaman yok!' }
        ]
      }
    }
  },

  'CM-M5-U2-L3': {
    lesson_id: 'CM-M5-U2-L3',
    title: 'Senaryo: Acil Durum',
    type: 'scenario',
    duration: 5,
    xp: 55,
    scenario: {
      question: '🚨 MÜLAKAT SORUSU: Acil Durum',
      context: '"Uçuş sırasında bir yolcu bayıldı. Ne yaparsınız?"',
      options: [
        { id: 'A', text: 'Hemen Kaptan\'a haber ver', isCorrect: false },
        { id: 'B', text: 'Yolcuyu kontrol et, ilk yardım başlat, yardım iste', isCorrect: true },
        { id: 'C', text: 'Çevredekilere uzaklaşın de', isCorrect: false },
        { id: 'D', text: 'Doktor anons yap', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Sıra: 1) Bilinç kontrolü 2) İlk yardım 3) Ekip yardımı 4) Doktor anons 5) Kaptan bilgi',
        wrong: '❌ Önce yolcuya müdahale, sonra diğer adımlar!'
      },
      explanation: 'Tıbbi acilde: Değerlendir → Müdahale et → Yardım iste → Raporla'
    }
  },

  // ==================== ÜNİTE 3: MOTİVASYON SORULARI ====================
  'CM-M5-U3-L1': {
    lesson_id: 'CM-M5-U3-L1',
    title: 'Neden Kabin Memuru?',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '❓ "Neden Kabin Memuru?" - Doğru Cevap',
      intro: 'Bu soru HER mülakatta sorulur. Yanlış cevap = ELEME',
      categories: [
        { icon: '❌', title: 'YANLIŞ', examples: '"Gezmek istiyorum"', desc: 'Yüzeysel, bencil' },
        { icon: '❌', title: 'YANLIŞ', examples: '"İyi maaş"', desc: 'Motivasyonsuz' },
        { icon: '✅', title: 'DOĞRU', examples: '"Hizmet ve güvenlik tutkusu"', desc: 'Mesleği anlıyor' },
        { icon: '✅', title: 'DOĞRU', examples: '"Takım çalışması ve sorumluluk"', desc: 'Değerlerle uyumlu' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En iyi motivasyon cevabı?',
        options: [
          { text: 'Dünyayı gezmek hayalım', isCorrect: false, feedback: '❌ ELEME! Bencil motivasyon.' },
          { text: 'Hizmet tutkusu ve takım çalışması', isCorrect: true, feedback: '✅ Mesleğin özünü anlıyor!' },
          { text: 'Üniforma giymek istiyorum', isCorrect: false, feedback: '❌ Yüzeysel!' }
        ]
      }
    }
  },

  'CM-M5-U3-L2': {
    lesson_id: 'CM-M5-U3-L2',
    title: 'Neden Bu Havayolu?',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '✈️ "Neden [Havayolu]?" - Araştırma ŞART',
      intro: 'Şirkete özel cevap vermelisin!',
      facts: [
        { icon: '🏆', title: 'Başarılar', text: 'Ödüller, Skytrax sıralaması' },
        { icon: '🌐', title: 'Network', text: 'Destinasyon sayısı, hub\'lar' },
        { icon: '💡', title: 'Değerler', text: 'Şirket vizyonu ve kültürü' },
        { icon: '✈️', title: 'Filo', text: 'Uçak tipleri, yenilikler' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'THY için iyi bir cevap?',
        options: [
          { text: 'Büyük şirket, iyi maaş', isCorrect: false, feedback: '❌ Yüzeysel!' },
          { text: 'Star Alliance, 120+ ülke, Skytrax 4 yıldız', isCorrect: true, feedback: '✅ Araştırma yapmış!' },
          { text: 'Türkiye\'nin en büyüğü', isCorrect: false, feedback: '❌ Daha spesifik ol!' }
        ]
      }
    }
  },

  'CM-M5-U3-L3': {
    lesson_id: 'CM-M5-U3-L3',
    title: 'Senaryo: Motivasyon Testi',
    type: 'scenario',
    duration: 5,
    xp: 50,
    scenario: {
      question: '💼 MÜLAKAT: Motivasyon',
      context: '"Bu meslekte en zorlayıcı ne olurdu sizce?"',
      options: [
        { id: 'A', text: 'Uzun saatler ve yorgunluk', isCorrect: false },
        { id: 'B', text: 'Zor yolcularla başa çıkmak ama bu benim için gelişim fırsatı', isCorrect: true },
        { id: 'C', text: 'Aileden uzak kalmak', isCorrect: false },
        { id: 'd', text: 'Zorluk görmüyorum', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Zorluğu kabul et AMA pozitif çerçevele!',
        wrong: '❌ Ya çok negatif ya çok gerçekdışı!'
      },
      explanation: 'Zorlukları kabul et ama "gelişim fırsatı", "zorluk beni motive ediyor" gibi pozitif çerçevele.'
    }
  },

  'CM-M5-U3-L4': {
    lesson_id: 'CM-M5-U3-L4',
    title: '🎮 Sürükle-Bırak: Doğru Cevap',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: '"Neden kabin memuru?" cevabını SIRALA',
      items: [
        { text: '💗 Hizmet tutkusu', order: 1 },
        { text: '👥 Takım çalışması sevgisi', order: 2 },
        { text: '🌐 Farklı kültürlerle iletişim', order: 3 },
        { text: '✈️ Dinamik çalışma ortamı', order: 4 },
        { text: '📚 Sürekli gelişim fırsatı', order: 5 }
      ]
    }
  },

  // ==================== ÜNİTE 4: SENARYO BAZLI SORULAR ====================
  'CM-M5-U4-L1': {
    lesson_id: 'CM-M5-U4-L1',
    title: 'Zor Yolcu Türleri',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '😠 Zor Yolcu Profilleri',
      intro: 'Farklı zor yolcu türleri ve yaklaşım:',
      categories: [
        { icon: '😡', title: 'Kızgın', examples: 'Rötar, koltuk sorunu', desc: 'Empati + Çözüm' },
        { icon: '🍺', title: 'Alkollü', examples: 'Fazla içmiş', desc: 'Sakin + Kararlı' },
        { icon: '😨', title: 'Korkulu', examples: 'Uçuş korkusu', desc: 'Rahatlatma + Bilgi' },
        { icon: '😤', title: 'Talepkar', examples: 'Sürekli şikayet', desc: 'Profesyonellik' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Uçuş korkusu olan yolcuya?',
        options: [
          { text: 'İstatistik ver, güvenli', isCorrect: false, feedback: '❌ Duygusal desteğe ihtiyacı var!' },
          { text: 'Göz teması, sakin ses, yanında ol', isCorrect: true, feedback: '✅ Empati + Rahatlatma!' },
          { text: 'Kendi işine bak, ilgilenme', isCorrect: false, feedback: '❌ Görevin!' }
        ]
      }
    }
  },

  'CM-M5-U4-L2': {
    lesson_id: 'CM-M5-U4-L2',
    title: 'Tıbbi Acil Durumlar',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🏥 Tıbbi Acil Durumlar',
      intro: 'Sık karşılaşılan tıbbi durumlar:',
      facts: [
        { icon: '💨', title: 'Bayılma', text: 'Ayakları kaldır, hava ver, bilinç kontrol' },
        { icon: '❤️', title: 'Kalp Krizi', text: 'AED, CPR, doktor anons' },
        { icon: '🩸', title: 'Alerji', text: 'Epipen, oksijen, tıbbi kit' },
        { icon: '🤢', title: 'Mide Bulantısı', text: 'Torba, su, rahat konum' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Yolcu bayıldığında ilk adım?',
        options: [
          { text: 'Doktor anons yap', isCorrect: false, feedback: '❌ Önce değerlendir!' },
          { text: 'Bilinç kontrol et, solunum kontrol et', isCorrect: true, feedback: '✅ ABC: Airway, Breathing, Circulation!' },
          { text: 'Kaptana haber ver', isCorrect: false, feedback: '❌ Önce müdahale!' }
        ]
      }
    }
  },

  'CM-M5-U4-L3': {
    lesson_id: 'CM-M5-U4-L3',
    title: 'Senaryo: Türbülans Krizi',
    type: 'scenario',
    duration: 5,
    xp: 55,
    scenario: {
      question: '🌊 MÜLAKAT: Türbülans',
      context: '"Servis sırasında şiddetli türbülans başladı. Ne yaparsınız?"',
      options: [
        { id: 'A', text: 'Servise devam et, panik yapma', isCorrect: false },
        { id: 'B', text: 'Trolley\'i kilitle, güvenli pozisyon al, yolcuları uyar', isCorrect: true },
        { id: 'C', text: 'Koşarak yerime dön', isCorrect: false },
        { id: 'D', text: 'Yolculara bağır', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 GÜVENLİK ÖNCE! Trolley kilitle → En yakın koltuğa → Kemer tak',
        wrong: '❌ Türbülansta yürümek/koşmak çok tehlikeli!'
      },
      explanation: 'Şiddetli türbülansta: 1) Servisi bırak 2) Ekipmanı güvenle 3) En yakın güvenli yere 4) Kemer tak'
    }
  },

  'CM-M5-U4-L4': {
    lesson_id: 'CM-M5-U4-L4',
    title: '🎮 Acil Durum Eşleştirme',
    type: 'matching',
    duration: 3,
    xp: 40,
    matching: {
      instruction: 'Durumu doğru müdahaleyle eşleştir',
      pairs: [
        { id: 1, left: 'Bayılma', right: 'Ayakları kaldır, hava ver' },
        { id: 2, left: 'Türbülans', right: 'Ekipmanı güvenle, kemer tak' },
        { id: 3, left: 'Yangın', right: 'PASS tekniği ile söndür' },
        { id: 4, left: 'Kalp krizi', right: 'CPR ve AED' },
        { id: 5, left: 'Uçuş korkusu', right: 'Empati ve rahatlatma' }
      ]
    }
  },

  // ==================== ÜNİTE 5: KİŞİSEL SORULAR ====================
  'CM-M5-U5-L1': {
    lesson_id: 'CM-M5-U5-L1',
    title: 'Güçlü ve Zayıf Yönler',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '💪 "Güçlü/Zayıf Yönünüz?"',
      intro: 'Klasik soru - HAZIRLIKLI OL!',
      categories: [
        { icon: '✅', title: 'Güçlü Yön', examples: 'İşle İLGİLİ özellik', desc: 'Empati, takım çalışması, stres yönetimi' },
        { icon: '⚠️', title: 'Zayıf Yön', examples: 'Gerçek ama geliştirilebilir', desc: 'Sabırsızlık, mükemmeliyetçilik' },
        { icon: '💡', title: 'Formul', examples: 'Zayıflık + Üzerinde çalışıyorum', desc: 'Gelişim odaklı' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En iyi "zayıf yön" cevabı?',
        options: [
          { text: 'Zayıf yönüm yok', isCorrect: false, feedback: '❌ Kişisel farkındalık eksik!' },
          { text: 'Mükemmeliyetçiyim ama esnek olmaya çalışıyorum', isCorrect: true, feedback: '✅ Farkındalık + Gelişim!' },
          { text: 'Sabahları zor kalkıyorum', isCorrect: false, feedback: '❌ İşle ilgisiz ve olumsuz!' }
        ]
      }
    }
  },

  'CM-M5-U5-L2': {
    lesson_id: 'CM-M5-U5-L2',
    title: '5 Yıl Sonra Nerede?',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '📅 "5 Yıl Sonra Nerede Görüyorsunuz?"',
      intro: 'Bu soru bağlılığını test eder',
      facts: [
        { icon: '❌', title: 'YANLIŞ', text: '"Pilot/Yönetici olmak istiyorum" - Mesleğe bağlı değil' },
        { icon: '❌', title: 'YANLIŞ', text: '"Bilmiyorum" - Hedefsiz' },
        { icon: '✅', title: 'DOĞRU', text: '"Deneyimli kabin memuru, belki Purser"' },
        { icon: '✅', title: 'DOĞRU', text: '"Eğitim verme veya yeni ekip üyeleri yetiştirme"' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En iyi "5 yıl" cevabı?',
        options: [
          { text: 'Pilot olmak istiyorum', isCorrect: false, feedback: '❌ Mesleğe bağlı değilsin!' },
          { text: 'Deneyimli bir ekip üyesi olarak gelişmek', isCorrect: true, feedback: '✅ Mesleğe bağlı ve gerçekçi!' },
          { text: 'Başka şirkete geçmek', isCorrect: false, feedback: '❌ Sadık değilsin!' }
        ]
      }
    }
  },

  'CM-M5-U5-L3': {
    lesson_id: 'CM-M5-U5-L3',
    title: 'Senaryo: Provokasyon Sorusu',
    type: 'scenario',
    duration: 5,
    xp: 50,
    scenario: {
      question: '🙄 MÜLAKAT: Provokasyon',
      context: '"Bu iş çok yorucu ve maaşı düşük. Gerçekten istediğinize emin misiniz?"',
      options: [
        { id: 'A', text: 'Maaşı araştırdım, farkındayım', isCorrect: false },
        { id: 'B', text: 'Tutku para değil, meslek sevgisi önemli', isCorrect: true },
        { id: 'C', text: 'Haklısınız, düşünmem lazım', isCorrect: false },
        { id: 'D', text: 'Diğer şirketler daha iyi mi?', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 PROVOKASYONA KANMA! Motivasyonunu göster, savunmaya geçme!',
        wrong: '❌ Provokasyon testini geçemedin!'
      },
      explanation: 'Bu sorular motivasyonunu test ediyor. Savunmaya geçme, tutkunu ve kararlılığını göster.'
    }
  },

  'CM-M5-U5-L4': {
    lesson_id: 'CM-M5-U5-L4',
    title: '⚡ Kişisel Soru Yarışı',
    type: 'timerace',
    duration: 3,
    xp: 50,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Zayıf yön sorusuna?', options: ['Yok', 'Geliştiriyorum', 'Hata', 'Geç'], correct: 1 },
        { q: '5 yıl hedefi?', options: ['Pilot', 'Deneyimli ekip', 'Farklı şirket', 'Bilmem'], correct: 1 },
        { q: 'Provokasyona?', options: ['Kız', 'Motivasyon göster', 'Pes et', 'Soru sor'], correct: 1 },
        { q: 'Güçlü yön örneği?', options: ['Yemek yaparım', 'Empati', 'Güzelım', 'Zengin'], correct: 1 },
        { q: '"Neden kabin memuru?"', options: ['Gezi', 'Hizmet tutkusu', 'Maaş', 'Üniforma'], correct: 1 },
        { q: 'En önemli özellik?', options: ['Güzellik', 'Boy', 'Takım ruhu', 'Para'], correct: 2 }
      ]
    }
  },

  // ==================== ÜNİTE 6: EKİP ÇALIŞMA SORULARI ====================
  'CM-M5-U6-L1': {
    lesson_id: 'CM-M5-U6-L1',
    title: 'Ekip İçi Çatışma',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '👥 "Ekip İçi Çatışma Nasıl Yönetirsiniz?"',
      intro: 'Ekip çatışması soruları çok yaygın',
      steps: [
        { level: 1, title: '👂 DİNLE', desc: 'Her iki tarafı dinle' },
        { level: 2, title: '🧐 ANLA', desc: 'Sorunu tam anla' },
        { level: 3, title: '🤝 ARABULUCU OL', desc: 'Orta yol bul' },
        { level: 4, title: '🎯 ÇÖZÜM', desc: 'Kazan-kazan çözümü' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'İki meslektaş tartışıyorsa?',
        options: [
          { text: 'Karışma, kendi işine bak', isCorrect: false, feedback: '❌ Ekip uyumu senin de sorumluluğun!' },
          { text: 'Arabulucu ol, ortak nokta bul', isCorrect: true, feedback: '✅ Profesyonel yaklaşım!' },
          { text: 'Purser\'a şikayet et', isCorrect: false, feedback: '❌ Önce kendin çözmeyi dene!' }
        ]
      }
    }
  },

  'CM-M5-U6-L2': {
    lesson_id: 'CM-M5-U6-L2',
    title: 'Senaryo: Zor Meslektaş',
    type: 'scenario',
    duration: 5,
    xp: 50,
    scenario: {
      question: '😤 MÜLAKAT: Zor Meslektaş',
      context: '"Ekip arkadaşınız görevlerini yerine getirmiyor ve yük size kalıyor. Ne yaparsınız?"',
      options: [
        { id: 'A', text: 'Purser\'a şikayet et', isCorrect: false },
        { id: 'B', text: 'Özel olarak konuş, yardım teklif et', isCorrect: true },
        { id: 'C', text: 'Sen de işi yapma, adil olsun', isCorrect: false },
        { id: 'D', text: 'Görmezden gel, sen halledersin', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Önce bireysel çözüm: Anlamaya çalış, yardım teklif et',
        wrong: '❌ İlk adım her zaman bireysel iletişim!'
      },
      explanation: 'Sıra: 1) Kişisel konuşma 2) Yardım teklifi 3) Çözülmezse eskale et'
    }
  },

  'CM-M5-U6-L3': {
    lesson_id: 'CM-M5-U6-L3',
    title: '🎮 STAR Eşleştirme',
    type: 'matching',
    duration: 3,
    xp: 40,
    matching: {
      instruction: 'STAR metodunu doğru sırayla eşleştir',
      pairs: [
        { id: 1, left: 'S - Situation', right: 'Durumu tanımla' },
        { id: 2, left: 'T - Task', right: 'Görevini açıkla' },
        { id: 3, left: 'A - Action', right: 'Yaptıklarını anlat' },
        { id: 4, left: 'R - Result', right: 'Sonucu paylaş' }
      ]
    }
  },

  // ==================== ÜNİTE 7: FİNAL ====================
  'CM-M5-U7-L1': {
    lesson_id: 'CM-M5-U7-L1',
    title: '🎓 Modül 5 Final Sınavı',
    type: 'exam',
    duration: 10,
    xp: 120,
    exam: {
      questions: [
        { q: 'Zor yolcuya ilk tepki?', options: ['Kural söyle', 'Empati kur', 'Purser\'a git', 'Görmezden gel'], correct: 1 },
        { q: 'Acil durumda öncelik?', options: ['Uçak', 'Eşya', 'Hayat', 'Zaman'], correct: 2 },
        { q: '"Neden kabin memuru?" - Yanlış?', options: ['Hizmet', 'Gezme', 'Takım', 'Gelişim'], correct: 1 },
        { q: 'Bayılmada ilk adım?', options: ['Anons', 'Bilinç kontrol', 'Kaptan', 'Kaç'], correct: 1 },
        { q: 'Zayıf yön cevabı?', options: ['Yok', 'Geliştiriyorum', 'Hata', 'Geç'], correct: 1 },
        { q: '5 yıl hedefi?', options: ['Pilot', 'Deneyimli ekip', 'Ayrılmak', 'Bilmem'], correct: 1 },
        { q: 'Türbülansta?', options: ['Servise devam', 'Güvenli pozisyon', 'Koş', 'Bağır'], correct: 1 },
        { q: 'Ekip çatışmasında?', options: ['Karışma', 'Arabulucu ol', 'Şikayet', 'Tartış'], correct: 1 },
        { q: 'Komut aldığında?', options: ['Soru sor', 'Tekrarla, uygula', 'Bekle', 'Reddet'], correct: 1 },
        { q: 'STAR\'da A?', options: ['Action', 'Analysis', 'Answer', 'Always'], correct: 0 }
      ]
    }
  }
};

export default cabinCrewContentsM5Interactive;
